import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {state} from 'lit/decorators/state.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {msg} from '@lit/localize';

import {FeatureSelect} from './featureSelect';

import info from '../../../icons/info';

import {pimText} from '../../util/values';

@customElement('feature-combo-select')
export class FeatureComboSelect extends FeatureSelect {

	static styles = [
		FeatureSelect.styles,
		css`
			:host {
			}

			.active button {
				height: 0;
				opacity: 0;
				padding: 0;
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.list {
				max-height: 200px;
				overflow: auto;
				margin-top: 2px;
			}

			.values {
				display: flex;
				flex-direction: column;
				border: var(--border-widget);
				overflow-y: auto;
				max-height: 300px;
			}

			.values.notSatisfied {
				border-left-color: var(--color-warn);
			}

			.icon {
				width: 11px;
				height: 11px;
				padding: 5px;
				display: inline-block;
			}

			.icon svg {
				display: block;
				fill: currentColor
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.icon.satisfied {
				color: var(--color-grey5);
			}

			.notSatisfied {
				color: var(--color-warn);
			}

			button {
				display: block;
				overflow: hidden;
				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-text-widget);
				background-color: transparent;
				border: 0 none;
				height: var(--height-widget);

				line-height: 120%;
				margin: 0;
				cursor: pointer;
				width: 100%;
				text-align: left;
			}

			.active button {
				height: 0;
				opacity: 0;
				padding: 0;
			}

			.search {
				display: flex;
				flex-direction: column;
				border: 1px solid var(--color-widget-border);
				overflow-y: auto;
				max-height: 200px;
				padding: 0 0.5rem;
			}

			.input {
				display: block;
				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-white);
				background-color: var(--color-background-widget);
				border: 0;
				height: var(--height-widget);
				//min-height: var(--height-widget);
				line-height: 120%;
				margin: 0;
				cursor: pointer;
				width: auto;
				text-align: left;
				outline: none;
			}

		`];

	@state()
	_active = false;

	@property({type: String})
	search = 'df';

	activate() {
		this._active = true;
	}
	deactivate() {
		this._active = false;
		this.search = '';
	}
	onBlur() {
		setTimeout(() => {
			this.deactivate();
			}, 1000);
	}

	constructor() {
		super();
		this.search = '';
		this.addEventListener('activate-combo', (e) => {
			this.activate();
			e.target.value = '';
		});
		this.addEventListener('deactivate-combo', (e) => {
			this.deactivate();
			e.target.value = '';
		});
		this.addEventListener('select-value', (e) => {
			e.target.value = '';
		});
	}

	onInput(e) {
		const el = e.target;
		if (el.id === 'search') {
			this.search = el.value;
		}
	}

	normalize(str) {
		return str.replace(/[\n\r\s\t]+/g, '').toLowerCase();
	}

	filteredValues(values) {
		if (this.search && this.search.length > 0) {
			return [...values].filter(
				featureValue => {
					const label = pimText(this.lang, this.feature.variableId, 'FV', this.decisions, this.translations, featureValue.featureValueId).toLowerCase();
					return label.indexOf(this.search.toLowerCase()) !== -1;
				}
			);
		} else {
			return values;
		}
	}
	render() {
		return html`
			<div>
				<div class="title">
					<trans-label
						key="${this.feature.variableId}"
						context="F"
						title="${this.feature.variableId}">
					</trans-label>
					${when(this.hasFeatureDescription(), () => html`
						<button class="info" @click="${this.openModal}">
							${info}
						</button>
					`)}
					<span class="selectedValue">
						${this.selectedFeatureValue().map(value => html`
							<trans-label
								key="${this.feature.variableId}"
								context="FV">
							</trans-label>
						`)}
					</span>
				</div>
				<div class="search">
					<input @focus="${this.activate}" @blur="${this.onBlur}" id="search" class="input" placeholder="Suche" type="text" @input=${this.onInput} .value=${this.search} autocomplete="off">
				</div>

			<div @focus="${this.activate}" class="list">
				${repeat(this.filteredValues(this.feature.values),
					(featureValue) => featureValue.featureValueId,
					(featureValue) => html`
						<feature-combo-select-item class="item"
												   .active=${this._active}
												   .feature=${this.feature}
												   .featureValue=${featureValue}
												   .productData=${this.getProductData(featureValue.featureValueId)}
												    >
						</feature-combo-select-item>
					`)}
			</div>

			</div>
		`;
	}
}
